import { Component, Input, Output, EventEmitter, OnInit, OnChanges, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

@Component({
    selector: 'app-navigation-tabs',
    imports: [CommonModule, MatIconModule],
    templateUrl: './navigation-tabs.html',
    styleUrl: './navigation-tabs.scss'
})
export class NavigationTabs implements OnInit, OnChanges {
  @Input() activeTab: 'available-cabs' | 'my-bookings' = 'my-bookings';
  @Output() tabChange = new EventEmitter<'available-cabs' | 'my-bookings'>();

  private readonly authService = inject(AuthService);
  showLoginModal = false;

  constructor(private router: Router) {}

  ngOnInit() {
  }

  ngOnChanges() {
  }

  isLoggedIn(): boolean {
    return this.authService.isUserLoggedIn();
  }

  showLoginForm() {
    this.showLoginModal = true;
    this.authService.showLoginForm();
  }

  onTabClick(tab: 'available-cabs' | 'my-bookings') {
    if(tab === 'available-cabs') {
      this.router.navigate(['/booking-search'], { queryParams: { tab: tab } });
      this.tabChange.emit(tab);
    } else {
      // Check if user is logged in for my-bookings tab
      if (this.isLoggedIn()) {
        this.router.navigate(['/my-bookings'], { queryParams: { tab: tab } });
        this.tabChange.emit(tab);
      } else {
        // Show login dialog if not logged in
        this.showLoginForm();
        this.router.navigate(['/']);
      }
    }
  }
} 